<template>
  <div class="home">
    <div class="home-inner">
      <h1 class="home-logo">
        搜狗视频
      </h1>
      <SearchBar />
    </div>
  </div>
</template>

<script>
import { getSsrUigsParams } from '../common/js/util';
import SearchBar from './components/SearchBar';

export default {
  components: {
    SearchBar,
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('home/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_HOME_ERROR]', err));
  },
  mounted() {
    const params = getSsrUigsParams();
    window.UIGS_PARA = params;
    this.$uigs.send(params);
  },
};
</script>

<style lang="scss">
.home {
  position: relative;
  min-height: 100vh;
  background: #a9cbe0 url('~@asset/img/home/home_bg.jpg') center top no-repeat;
  background-size: cover;

  html[data-theme='dark'] & {
    background-color: #1a1a1a;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.6);
      pointer-events: none;
    }
  }
}

.home-inner {
  position: relative;
  z-index: 1;
  padding: 26vh 20px 0;
  box-sizing: border-box;
}

.home-logo {
  height: 33px;
  margin: 0 auto 24px;
  overflow: hidden;
  font-size: 0;
  background: url('~@asset/img/home/index_logo.png') center center no-repeat;
  background-size: contain;

  html[data-theme='dark'] & {
    opacity: 0.85;
  }
}
</style>
